import styled from 'styled-components';
import { ToggleButton as ButtonBase, ToggleButtonProps } from '@mui/material';
import { ComponentSize } from '../../types/types';
import { componentToken } from '../../style/utils';

type Props = ToggleButtonProps & {
  color?: 'warning' | 'error';
  size?: ComponentSize;
};

const ToggleButton = styled(ButtonBase)<Props>`
  text-transform: none;
  padding-top: ${componentToken('toggleButton.root.paddingTop')};
  padding-bottom: ${componentToken('toggleButton.root.paddingBottom')};
  min-height: ${({ size }) => (size === 'large' ? '40px' : '32px')};
  height: fit-content;
  color: ${componentToken('toggleButton.root.color')};
  border-color: ${componentToken('toggleButton.root.borderColor')};
  border-radius: ${componentToken('toggleButton.root.borderRadius')};
  white-space: nowrap;

  &.Mui-selected {
    background: ${componentToken('toggleButton.root.selectedBackground')};
    color: ${componentToken('toggleButton.root.selectedColor')};
  }

  ${({ color, theme }) =>
    color === 'error'
      ? `
    &:hover {
        color: ${theme.tokens.components.toggleButton.root.hoverColor} !important;
        background: ${theme.tokens.components.toggleButton.root.hoverBackground} !important;
    }
    `
      : color === 'warning'
      ? `
    &:hover {
        color: ${theme.tokens.components.toggleButton.root.warningHoverColor} !important;
        background: ${theme.tokens.components.toggleButton.root.warningHoverBackground} !important;
    }
    `
      : ``};
`;

export default ToggleButton;
